import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background: var(--background);
    color: var(--text-primary);
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  button {
    font-family: inherit;
  }

  input, select, textarea {
    font-family: inherit;
    color: var(--text-primary);
    background: var(--surface);
  }

  ::placeholder {
    color: var(--text-tertiary);
  }

  /* Remove system dark mode influence */
  @media (prefers-color-scheme: dark) {
    html {
      color-scheme: light;
    }
  }
`;

export default GlobalStyle; 